<template>
  <div class="container">
    <div class="box-container">
        <img src="../assets/imlca-logo.png">
        <h1>Please email <span>bobby@imlcacoaches.com</span> to activate your account.</h1> 
    </div>
  </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss" scoped>
    .box-container{
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;

        img{
            margin-bottom: 15px;
            width: 150px;
        }

        h1{
            font-size: 24px;
            font-weight: 400;
            letter-spacing: 0;

            span{
                color: #005fa7;
            }
        }
    }
</style>